import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
/**
 * CouponThreshold 组件
 * 用于展示优惠券使用门槛，如"满38可用"、"无门槛"等
 * 超出容器宽度时自动显示省略号
 */
const CouponThreshold = ({ text, className = '', style }) => {
    return <View className={`coupon-threshold ${className}`} style={style}>
      <Text className="coupon-threshold-text" numberOfLines={1}>
        {text}
      </Text>
    </View>;
};
export default memo(CouponThreshold);
